import { render, staticRenderFns } from "./EmptyOverview.vue?vue&type=template&id=1befd9ac&scoped=true&"
import script from "./EmptyOverview.vue?vue&type=script&lang=js&"
export * from "./EmptyOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1befd9ac",
  null
  
)

/* custom blocks */
import block0 from "./EmptyOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports